var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mobile)?_c('mobile',{attrs:{"id":_vm.id}}):_c('pc',{attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }